"use client";

import { useEffect, useState, type ReactNode } from "react";

/**
 * Renders its children only after the component has mounted in the
 * browser - server-side rendering emits NOTHING.
 *
 * 2026-09-03 crawler-cleanliness fix: Next.js streams a route's
 * loading.tsx fallback into the HTML document BEFORE the page content
 * on every server-rendered request, and the fallback markup stays in
 * the document after the content arrives. On /c/<slug> that put the
 * searching scene's "Hunting your best deal" <h1> ahead of the real
 * product <h1> in the raw HTML that no-JS crawlers (GPTBot, ClaudeBot,
 * PerplexityBot) extract. Wrapping the fallback in this gate keeps the
 * crawler-visible document clean while changing nothing a person sees:
 * client-side navigations (homepage chips, /compare redirects - the
 * case loading.tsx exists for) render loading.tsx in the browser,
 * where this mounts on the next frame.
 *
 * Trade-off, accepted: a DIRECT visit to an UNPUBLISHED slug shows a
 * blank canvas for the ~second until hydration, then the scene runs
 * for the 30-60s search. Those pages are noindex and unlinked, so the
 * visitors are rare; published pages stream their content immediately.
 */
export function ClientOnlyLoading({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? <>{children}</> : null;
}
